export default "__VITE_ASSET__D_oVvp3I__"